/* eslint-disable */
import { Country } from "../../models/common/country.model";
import { GeoAddress } from "../../models/common/geo-address.model";
import { LatLng } from "../../models/common/lat-lng";
import { Customer } from "../../customer/customer.model";
import { Location } from "../../location/location.model";
import { PayloadItemView } from "../../models/meta-params/payload-item-view";
import { ShipmentChargeLine } from "./charge-line/shipment-charge-line";
import { ShipmentDeliveryAttachment } from "./shipment-delivery.attachment";
import { ShipmentNominationPack } from "./nomination/shipment-nomination.pack";
import { Company } from "../../company/company.model";
import { TripType } from "../../models/vehicle/trip-type";
import { PersonalPaymentMethod } from "../../models/payments/personal-payment-method.model";
import { VehicleParaPack } from "../../fleet/vehicle/params/vehicle-para-pack";
import { ShipmentJobStatus } from "./delivery/shipment-job.status";
import { ShipmentWaypoint } from "./waypoint/shipment.waypoint";
import { ShipmentType } from "./shipment-type.enum";
import { BookingOption } from "./shipment-booking-option.enum";
import { ShipmentDelivery } from "./delivery/shipment-delivery.model";
import { VehicleParaPackView } from "../../fleet/vehicle/params/vehicle-para-pack-view";
import { ShipmentRemark } from "./shipment-remark.model";
import { DeliveryNoteLogisticsProject } from "./delivery-note-logistics-project";
import { PaymentTerm } from '../../order/models/payment-term.model';
import { AuditActorSummary } from '../../shared/audit/audit.models';

export class Shipment {
    shipmentId?: number;
    shipmentNumber: string;
    externalReference?: string;
    priority?: string;
    parentShipmentId?: number;
    customerOrderNumber?: string;
    crmClientId?: number;
    crmAccountId?: number;
    crmClientContactId?: number;
    crmClientName?: string;
    crmAccountName?: string;
    crmClientContactName?: string;
    kamCustomerId?: number;
    kamCustomerName?: string;
    customer: Customer;
    company: Company;
    owningCompany: Company;
    owningCompanyContact: Customer;

    requestedBookingOption: BookingOption;
    requestedBookingTime: number; // timestamp

    shipmentType: ShipmentType;
    nationalityPref?: Country;
    countryOfOrder: Country;

    pickupAddress: GeoAddress;
    dropoffAddress: GeoAddress;
    searchAddress?: GeoAddress;

    pickupLocation: LatLng;
    dropoffLocation: LatLng;
    searchLocation?: LatLng;

    sourceLocation: Location;
    destinationLocation: Location;
    waypoints: ShipmentWaypoint[] = [];

    distance?: number;
    time?: number;
    tripType?: TripType;

    totalJobWorth: number;
    totalFareQuote?: number;
    selectedPaymentMethod: PersonalPaymentMethod;
    paymentTerm?: PaymentTerm;
    vehicleParaPack: VehicleParaPackView = new VehicleParaPackView();

    insuredNeeded: boolean = true;
    fixedRate: boolean = true;
    customerVehicleSelect: boolean = false;
    singleDriverRepeat: boolean = false;

    maxDeliveryIndex?: number;
    payloadItemList: PayloadItemView[] = [];

    // --- Collection Fields ---
    nominationPack: ShipmentNominationPack;
    // Using Record<string, T> for HashMap
    deliveries: ShipmentDelivery[] = [];
    deliveryStatusMap: Record<string, ShipmentJobStatus> = {};
    filesList: ShipmentDeliveryAttachment[] = [];

    // --- Enterprise Fields ---
    creationDate?: number; // timestamp
    createdAt?: number | null;
    createdBy?: number | null;
    updatedAt?: number | null;
    updatedBy?: number | null;
    createdByActor?: AuditActorSummary | null;
    updatedByActor?: AuditActorSummary | null;
    quantityRequired?: number;
    pickupCity?: string;
    dropoffCity?: string;
    orderCity?: string;
    pickupCountry?: Country;
    dropoffCountry?: Country;
    pickupTime?: Date;
    dropoffTime?: Date;
    sellingPrice?: number;
    billingMode?: 'STANDARD' | 'CONSOLIDATED_ZERO_SELL' | 'CONSOLIDATED_PER_PARTY';
    warehouseFlowDirection: 'OUTBOUND' | 'INBOUND' = 'OUTBOUND';
    buyingPrice?: number;
    currencyCode?: string;
    pricingRateSource?: string;
    buyingPriceSource?: string;
    sellingPriceSource?: string;
    resourceOwnershipType?: string;
    resourceCompanyId?: number;
    supplierCrmClientId?: number;
    supplierCompanyId?: number;
    supplierContractId?: number;
    supplierContractRevisionId?: number;
    supplierRateCardId?: number;
    recommendedBuyingPrice?: number;
    pricingWarning?: string;
    pricingContractId?: number;
    pricingContractRevisionId?: number;
    pricingRateCardId?: number;
    pricingOverrideReason?: string;
    pricingInternalCostCardId?: number;
    pricingInternalCostMatchType?: string;
    pricingInternalCostAmount?: number;
    pricingInternalCostCurrencyCode?: string;
    pricingInternalCostWaitingThresholdMinutes?: number;
    pricingInternalCostWaitingChargeAmount?: number;
    shipmentStatus: string = 'NEW';
    workflowState?: string;
    workflowUpdatedAt?: number;
    posmProjectId?: number;
    logisticsProjectId?: number;
    includedLogisticsProjects: DeliveryNoteLogisticsProject[] = [];
    transportPlanId?: number;
    transportRouteId?: number;
    primaryTransportReleaseId?: number;
    primaryTransportReleaseNumber?: string;
    crossDockOrchestrationId?: number;
    crossDockOrchestrationNumber?: string;
    remark?: ShipmentRemark;
    chargeLines: ShipmentChargeLine[] = [];
    routeType?: string;
    serviceCategory?: string;

    constructor(init?: Partial<Shipment>) {
        Object.assign(this, init);
    }
}
